var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubmit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1846_33970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2949 8.88376L4.95681 9.68473C3.92003 9.75094 3.47485 11.0364 4.24886 11.7302L8.28086 15.3676C8.44662 15.5193 8.56138 15.703 8.62512 15.9185L10.1269 21.137C10.4112 22.1368 11.7616 22.3001 12.2756 21.3973L18.4042 10.659C18.508 10.4745 18.5601 10.2655 18.5552 10.0539C18.5503 9.84227 18.4886 9.63588 18.3764 9.45638C18.2642 9.27687 18.1058 9.13088 17.9178 9.03371C17.7297 8.93655 17.519 8.8918 17.3077 8.90416L17.2949 8.88376Z",
    fill: "#636363"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1846_33970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.046,
    height: 19.2491,
    fill: "white",
    transform: "translate(0 9.56293) rotate(-32)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmit);
export default __webpack_public_path__ + "static/media/submit.e871e1d694d54ba1f4e97fec27c0125e.svg";
export { ForwardRef as ReactComponent };